import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import TextSearchIcon from "./text-search.svg";

export default class ShowCharactersUI extends Plugin {
  init() {
    const editor = this.editor;

    editor.set("showCharacters", false);

    editor.ui.componentFactory.add("showCharacters", () => {
      const command = editor.commands.get("showCharacters");
      const showCharactersButtonView = new ButtonView();

      showCharactersButtonView.set({
        icon: TextSearchIcon,
        isToggleable: true,
        tooltip: true,
        withText: false,
      });

      showCharactersButtonView.bind("isOn").to(command, "value");
      showCharactersButtonView.bind("isEnabled").to(command, "isEnabled");
      showCharactersButtonView
        .bind("label")
        .to(command, "value", (value) =>
          value ? "Hide Characters" : "Show Characters",
        );
      showCharactersButtonView.on("execute", (e) => {
        command.execute(!command.value);
      });
      return showCharactersButtonView;
    });
  }
}
